var React = require('react');

function Bold (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#a)"},React.createElement("path",{"d":"M13 3v7h6l-8 11v-7H5l8-11z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"})));
}

Bold.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Bold;

Bold.default = Bold;
